import React from "react";
import WhyChooseUsNumericCard from "../../components/PageSection/WhyChooseUsCard";

type WhyChooseUsSectionProps = {
  title?: string;
  items: string[];
};

const WhyChooseUsSection: React.FC<WhyChooseUsSectionProps> = ({
  title = "Why Choose Us?",
  items,
}) => {
  return (
    <section className="pt-80 pb-80 bg-dark-gradient">
      <div className="container">
        <h2 className="xb-section-title text-center text-white wow fadeInUp">
          {title}
        </h2>

        <div className="row justify-content-center mt-50">
          {items.map((item, index) => (
            <div
              className="col-lg-4 col-md-6 mb-30 wow fadeInUp text-center"
              data-wow-delay={`${index * 100}ms`}
              key={index}
            >
              <WhyChooseUsNumericCard index={index} text={item} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
